module.exports = __webpack_public_path__ + "img/menu_logo_mirai.78ad872a.svg";